/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { analyticsAdminControllerGetSummaryV1 } from '../fn/analytics-admin/analytics-admin-controller-get-summary-v-1';
import { AnalyticsAdminControllerGetSummaryV1$Params } from '../fn/analytics-admin/analytics-admin-controller-get-summary-v-1';
import { AnalyticsSummaryDto } from '../models/analytics-summary-dto';

@Injectable({ providedIn: 'root' })
export class AnalyticsAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `analyticsAdminControllerGetSummaryV1()` */
  static readonly AnalyticsAdminControllerGetSummaryV1Path = '/api/v1/analytics/admin/summary';

  /**
   * GA4 활성 사용자 통계 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analyticsAdminControllerGetSummaryV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsAdminControllerGetSummaryV1$Response(params: AnalyticsAdminControllerGetSummaryV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AnalyticsSummaryDto>> {
    const obs = analyticsAdminControllerGetSummaryV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * GA4 활성 사용자 통계 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analyticsAdminControllerGetSummaryV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsAdminControllerGetSummaryV1(params: AnalyticsAdminControllerGetSummaryV1$Params, context?: HttpContext): Observable<AnalyticsSummaryDto> {
    const resp = this.analyticsAdminControllerGetSummaryV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AnalyticsSummaryDto>): AnalyticsSummaryDto => r.body)
    );
  }

}
